import { Badge } from '@karnov/kui-react'

import type { ComponentProps } from 'react'

type Environment = 'staging' | 'review' | 'development' | 'production'

type LabelVariants = Pick<ComponentProps<typeof Badge>, 'variant'>['variant']

const environmentVariant: Partial<Record<Environment, LabelVariants>> = {
  development: 'environment-development',
  staging: 'environment-staging',
  review: 'environment-test',
}

type Props = { environment?: Environment }

export const EnvironmentLabel = ({ environment }: Props = { environment: import.meta.env.VITE_NODE_ENV }) => {
  if (!environment || environment === 'production') return null
  return (
    <Badge variant={environmentVariant[environment]}>
      {environment.charAt(0).toUpperCase() + environment.slice(1)}
    </Badge>
  )
}
